import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import AppThemeProvider from "./theme/AppThemeProvider";
import Home from "./components/Home";
import FuturisticHome from "./components/FuturisticHome";
import YouTubeClone from "./components/YouTubeClone";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FAQ from "./components/FooterComponents/FAQ";
import Privacy from "./components/FooterComponents/Privacy";
import HelpCentre from "./components/FooterComponents/HelpCentre";
import CookiePreferences from "./components/FooterComponents/CookiePreferences";
import LegalNotices from "./components/FooterComponents/LegalNotices";
import MediaCentre from "./components/FooterComponents/MediaCentre";
import TermsOfUse from "./components/FooterComponents/TermsOfUse";
import ContactUs from "./components/FooterComponents/ContactUs";
import Navbar from "./components/Navbar";
import IndustryPortal from "./components/IndustryPortal";
import LandingPage from "./components/LandingPage";
import AuthApp from "./components/AuthApp";
import LUDashboard from "./components/LUDashboard";

const MainLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");

    if (pathname === "/") {
      html.classList.remove("portal-scroll-enabled");
      body.classList.remove("portal-scroll-enabled");
      root?.classList.remove("portal-scroll-enabled");
      [html, body, root].forEach((el) => {
        if (!el) return;
        el.style.overflow = "";
        el.style.height = "";
        el.style.minHeight = "";
        el.style.maxHeight = "";
      });
    } else {
      html.classList.remove("hide-scrollbar");
      body.classList.remove("hide-scrollbar");
    }
  }, [pathname]);

  return null;
};

function App() {
  return (
    <AppThemeProvider>
      <ToastContainer />
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<FuturisticHome />} />
          <Route path="/lu-dashboard" element={<LUDashboard />} />
          <Route path="/home-old" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/video" element={<MainLayout><YouTubeClone /></MainLayout>} />
          <Route path="/faq" element={<MainLayout><FAQ /></MainLayout>} />
          <Route path="/privacy" element={<MainLayout><Privacy /></MainLayout>} />
          <Route path="/help-centre" element={<MainLayout><HelpCentre /></MainLayout>} />
          <Route path="/cookie-preferences" element={<MainLayout><CookiePreferences /></MainLayout>} />
          <Route path="/legal-notices" element={<MainLayout><LegalNotices /></MainLayout>} />
          <Route path="/media-centre" element={<MainLayout><MediaCentre /></MainLayout>} />
          <Route path="/terms-of-use" element={<MainLayout><TermsOfUse /></MainLayout>} />
          <Route path="/contact-us" element={<MainLayout><ContactUs /></MainLayout>} />

          {/* Industry Portals */}
          <Route path="/finance" element={<IndustryPortal industry="finance" />} />
          <Route path="/healthcare" element={<IndustryPortal industry="healthcare" />} />
          <Route path="/insurance" element={<IndustryPortal industry="insurance" />} />
          <Route path="/government" element={<IndustryPortal industry="government" />} />
          <Route path="/corporate" element={<IndustryPortal industry="corporate" />} />

          {/* LegitimatelyU Authentication App */}
          <Route path="/auth-app" element={<AuthApp />} />

          {/* Futuristic Landing Page */}
          <Route path="/landing" element={<LandingPage />} />
        </Routes>
      </Router>
    </AppThemeProvider>
  );
}

export default App;